import {Button, Modal, OverlayTrigger, Tooltip} from "react-bootstrap"
import Spinner from "react-bootstrap/Spinner"
import {
  Inventory2Outlined,
  NewspaperOutlined,
  AccountCircleOutlined,
  HomeOutlined,
  QuestionAnswerOutlined,
  CheckBoxOutlined,
  DisabledByDefaultOutlined,
  ErrorOutline,
  ArtTrack,
  HighlightAlt
} from "@mui/icons-material"
import useAudit from "../../hooks/useAudit"
import {toast} from "react-hot-toast"
import useHome from "../../hooks/useHome"
import {useState, useEffect} from "react"
import ArticlesAudit from "../auditoria/ArticlesAudit"
import Noticias from "./auditsReplica/Noticias"
import Products from "./auditsReplica/Products"
import BloqueInfoAudit from "../auditoria/BloqueInfoAudit"

import FaqsAudit from "../auditoria/FaqsAudit"
import {formatearFecha} from "../../helpers/formatearFecha"
import BannerAudit from "../auditoria/BannerAudit"
import SidebarSlides from "../../components/pgi/SidebarSlides"
import SidebarSlidesNewsEdit from "../../components/pgi/SidebarSlidesNewsEdit"
import SidebarProductsEdit from "../../components/pgi/SidebarProductsEdit"
import SidebarFaqs from "../../components/pgi/SidebarFaqs"
import BloqueTxtPgi from "../../components/pgi/BloqueTxtPgi"
import BannerPubPgi from "../../components/pgi/BannerPubPgi"

const Index = () => {
  const [showGaleria, setShowGaleria] = useState(false)
  const [modalFor, setModalFor] = useState(null)
  const {setBannerEdit, setBloqueInfoEdit} = useHome()

  const userpgi = JSON.parse(localStorage.getItem("Usuario"))?.UserLogin?.name
  const fecha = JSON.parse(localStorage.getItem("Usuario"))?.UserLogin
    ?.lastConectionDate
  const lastConection = new Date(fecha).toLocaleDateString("es", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
  })

  const {audit, deleteAudit, handleApprovedRequest, getAllAudits} = useAudit()
  
  useEffect(() => {
    getAllAudits();
  }, [])
  

  const handleApproved = (auditId) => {
    const toastId = toast(
      <div className="flex-column">
        <div className="text-center error_icon">
          <ErrorOutline />
        </div>
        <div className="text-center my-2">
          ¿Estás seguro de aceptar esta publicación?
        </div>
        <br />
        <div className="d-flex justify-content-around">
          <Button
            className="w-40 button_error"
            variant="danger"
            onClick={() => handleConfirmApproved(auditId)}>
            Si
          </Button>
          <Button
            className="w-40 button_error"
            variant="secondary"
            onClick={() => toast.dismiss(toastId)}>
            No
          </Button>
        </div>
      </div>,
      {
        duration: 20000
      }
    )
  }

  const handleConfirmApproved = (auditId) => {
    handleApprovedRequest(auditId)
    handleCloseGaleria()
    toast.dismiss()
  }

  const handleDelete = (auditId) => {
    const toastId = toast(
      <div className="flex-column">
        <div className="text-center error_icon">
          <ErrorOutline />
        </div>
        <div className="text-center my-2">
          ¿Estás seguro de eliminar esta publicación?
        </div>
        <br />
        <div className="d-flex justify-content-around">
          <Button
            className="w-40 button_error"
            variant="danger"
            onClick={() => handleConfirmDelete(auditId)}>
            Si
          </Button>
          <Button
            className="w-40 button_error"
            variant="secondary"
            onClick={() => toast.dismiss(toastId)}>
            No
          </Button>
        </div>
      </div>,
      {
        duration: 20000
      }
    )
  }

  const handleConfirmDelete = (auditId) => {
    deleteAudit(auditId)
    handleCloseGaleria()
    toast.dismiss()
  }

  const cantidadHome = audit?.filter(
    (a) => a?.changes?.element === 0 && a.checked === false && a
  )
  const cantidadNews = audit?.filter(
    (a) => a?.changes?.element === 1 && a.checked === false && a
  )
  const cantidadProducts = audit?.filter(
    (a) => a?.changes?.element === 2 && a.checked === false && a
  )
  const cantidadFaqs = audit?.filter(
    (a) => a?.changes?.element === 3 && a.checked === false && a
  )
  const cantidadBloque = audit?.filter(
    (a) => a?.changes?.element === 4 && a.checked === false && a
  )
  const cantidadBannerPub = audit?.filter(
    (a) => a?.changes?.element === 5 && a.checked === false && a
  )

  const handleCloseGaleria = () => setShowGaleria(false)
  const handleShowGaleria = () => setShowGaleria(true)

  const handleModalClick = (pend) => {
    if (pend.method === "PUT" || pend.method === "POST") {
      setModalFor(pend)
      handleShowGaleria()
    }
  }

  const filteredAudit = audit?.filter((item) => item.checked === false)

  const grouped = {}
  filteredAudit?.forEach((el) => {
    const id = el.changes._id
    if (!grouped[id]) {
      grouped[id] = []
    }
    grouped[id].push(el)
  })

  const latestElements = Object?.values(grouped)?.map((group) => {
    return group?.reverse(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    )[0]
  })

  return audit !== null ? (
    <div id="wrapperIndex" className="wrapperPgi">
      <div className="container containerPgi pt-3 pb-3">
        {/**CUERPO DE INDEX */}
        <header style={{marginBottom: "1rem"}}>
          <h1>
            <AccountCircleOutlined /> ¡Hola, {userpgi}!{" "}
            <span>
              NOTIFICACIONES EN <strong>PGI</strong>
            </span>
          </h1>
          <p>
            Estos son los últimos cambios desde que entraste por última vez el{" "}
            {lastConection}.
          </p>
        </header>
        <div id="pgi__notificaciones">
          {/**CARD BLOG */}
          <div className="card" id="pgiNotifNews">
            <header aria-labelledby="pgiNotifNews">
              <h2>
                <span className="text">
                  <HomeOutlined /> ARTÍCULOS | HOME
                </span>
                <span className="badge">{cantidadHome?.length}</span>
              </h2>
            </header>
            <div className="pgi__notificaciones">
              {cantidadHome.length > 0 ? (
                <ul>
                  {latestElements?.map(
                    (pend, index) =>
                      pend?.changes?.element === 0 &&
                      pend.checked === false && (
                        <li key={index}>
                          <div
                            className="description"
                            onClick={() => handleModalClick(pend)}>
                            {pend.method === "POST" && (
                              <span className="badge public">Creado</span>
                            )}
                            {pend.method === "DELETE" && (
                              <span className="badge delete">Eliminado</span>
                            )}
                            {pend.method === "PUT" && (
                              <span className="badge edit">Editado</span>
                            )}
                            <b>{pend?.changes?.title}</b>, el{" "}
                            {formatearFecha(pend?.date)} por{" "}
                            {pend?.changes?.creator}.
                          </div>
                          <div className="actions">
                            {userpgi === "Gerente" ? (
                              <>
                                <OverlayTrigger
                                  key="1"
                                  placement="top"
                                  overlay={
                                    <Tooltip id="1">Aceptar cambio</Tooltip>
                                  }>
                                  <button
                                    className="accept"
                                    onClick={() => handleApproved(pend?._id)}>
                                    <CheckBoxOutlined />
                                  </button>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  key="2"
                                  placement="top"
                                  overlay={
                                    <Tooltip id="2">Rechazar cambio</Tooltip>
                                  }>
                                  <button
                                    className="reject"
                                    onClick={() => handleDelete(pend?._id)}>
                                    <DisabledByDefaultOutlined />
                                  </button>
                                </OverlayTrigger>
                              </>
                            ) : (
                              pend?.method !== "DELETE" && (
                                <OverlayTrigger
                                  key="2"
                                  placement="top"
                                  overlay={
                                    <Tooltip id="2">Editar cambio</Tooltip>
                                  }>
                                  <button
                                    className="reject"
                                  >
                                    <SidebarSlides
                                      isEdit={true}
                                      sliderToEdit={pend?.changes}
                                    />
                                  </button>
                                </OverlayTrigger>
                              )
                            )}
                          </div>
                        </li>
                      )
                  )}
                </ul>
              ) : (
                <p>No hay pendientes</p>
              )}
            </div>
          </div>
          <div className="card" id="pgiNotifProducto">
            <header aria-labelledby="pgiNotifProducto">
              <h2>
                <span className="text">
                  <Inventory2Outlined /> PRODUCTOS
                </span>
                <span className="badge">{cantidadProducts?.length}</span>
              </h2>
            </header>
            <div className="pgi__notificaciones">
              {cantidadProducts?.length > 0 ? (
                <ul>
                  {latestElements?.map(
                    (pend, index) =>
                      pend?.changes?.element === 2 &&
                      pend.checked === false && (
                        <li key={index}>
                          <div
                            className="description"
                            onClick={() => handleModalClick(pend)}>
                            {pend.method === "POST" && (
                              <span className="badge public">Creado</span>
                            )}
                            {pend.method === "DELETE" && (
                              <span className="badge delete">Eliminado</span>
                            )}
                            {pend.method === "PUT" && (
                              <span className="badge edit">Editado</span>
                            )}
                            <b>{pend?.changes?.title}</b>, el{" "}
                            {formatearFecha(pend?.date)} por{" "}
                            {pend?.changes?.creator}.
                          </div>
                          <div className="actions">
                            {userpgi === "Gerente" ? (
                              <>
                                <OverlayTrigger
                                  key="1"
                                  placement="top"
                                  overlay={
                                    <Tooltip id="1">Aceptar cambio</Tooltip>
                                  }>
                                  <button
                                    className="accept"
                                    onClick={() => handleApproved(pend?._id)}>
                                    <CheckBoxOutlined />
                                  </button>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  key="2"
                                  placement="top"
                                  overlay={
                                    <Tooltip id="2">Rechazar cambio</Tooltip>
                                  }>
                                  <button
                                    className="reject"
                                    onClick={() => handleDelete(pend?._id)}>
                                    <DisabledByDefaultOutlined />
                                  </button>
                                </OverlayTrigger>
                              </>
                            ) : (
                              <OverlayTrigger
                                key="2"
                                placement="top"
                                overlay={
                                  <Tooltip id="2">Editar cambio</Tooltip>
                                }>
                                <button className="reject">
                                  <SidebarProductsEdit
                                    values={pend?.changes}
                                    isEdit={true}
                                  />
                                </button>
                              </OverlayTrigger>
                            )}
                          </div>
                        </li>
                      )
                  )}
                </ul>
              ) : (
                <p>No hay pendientes</p>
              )}
            </div>
          </div>
          <div className="card" id="pgiNotifHome">
            <header aria-labelledby="pgiNotifHome">
              <h2>
                <span className="text">
                  <NewspaperOutlined /> TENSONEWS
                </span>
                <span className="badge">{cantidadNews?.length}</span>
              </h2>
            </header>
            <div className="pgi__notificaciones">
              {cantidadNews?.length > 0 ? (
                <ul>
                  {latestElements?.map(
                    (pend, index) =>
                      pend?.changes?.element === 1 &&
                      pend.checked === false && (
                        <li key={index}>
                          <div
                            className="description"
                            onClick={() => handleModalClick(pend)}>
                            {pend.method === "POST" && (
                              <span className="badge public">Creado</span>
                            )}
                            {pend.method === "DELETE" && (
                              <span className="badge delete">Eliminado</span>
                            )}
                            {pend.method === "PUT" && (
                              <span className="badge edit">Editado</span>
                            )}
                            <b>{pend?.changes?.title}</b>, el{" "}
                            {formatearFecha(pend?.date)} por{" "}
                            {pend?.changes?.creator}.
                          </div>
                          <div className="actions">
                            {userpgi === "Gerente" ? (
                              <>
                                <OverlayTrigger
                                  key="1"
                                  placement="top"
                                  overlay={
                                    <Tooltip id="1">Aceptar cambio</Tooltip>
                                  }>
                                  <button
                                    className="accept"
                                    onClick={() => handleApproved(pend?._id)}>
                                    <CheckBoxOutlined />
                                  </button>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  key="2"
                                  placement="top"
                                  overlay={
                                    <Tooltip id="2">Rechazar cambio</Tooltip>
                                  }>
                                  <button
                                    className="reject"
                                    onClick={() => handleDelete(pend?._id)}>
                                    <DisabledByDefaultOutlined />
                                  </button>
                                </OverlayTrigger>
                              </>
                            ) : (
                              pend?.method !== "DELETE" && (
                                <OverlayTrigger
                                  key="2"
                                  placement="top"
                                  overlay={
                                    <Tooltip id="2">Editar cambio</Tooltip>
                                  }>
                                  <button
                                    className="reject"
                                  >
                                    <SidebarSlidesNewsEdit
                                      key={pend?._id}
                                      noticia={pend?.changes}
                                    />
                                  </button>
                                </OverlayTrigger>
                              )
                            )}
                          </div>
                        </li>
                      )
                  )}
                </ul>
              ) : (
                <p>No hay pendientes</p>
              )}
            </div>
          </div>
          <div className="card" id="pgiNotifFaqs">
            <header aria-labelledby="pgiNotifFaqs">
              <h2>
                <span className="text">
                  <QuestionAnswerOutlined /> PREGUNTAS FRECUENTES
                </span>
                <span className="badge">{cantidadFaqs?.length}</span>
              </h2>
            </header>
            <div className="pgi__notificaciones">
              {cantidadFaqs?.length ? (
                <ul>
                  {latestElements?.map(
                    (pend, index) =>
                      pend?.changes?.element === 3 &&
                      pend.checked === false && (
                        <li key={index}>
                          <div
                            className="description"
                            onClick={() => handleModalClick(pend)}>
                            {pend.method === "POST" && (
                              <span className="badge public">Creado</span>
                            )}
                            {pend.method === "DELETE" && (
                              <span className="badge delete">Eliminado</span>
                            )}
                            {pend.method === "PUT" && (
                              <span className="badge edit">Editado</span>
                            )}
                            <b>{pend?.changes?.category}</b>, el{" "}
                            {formatearFecha(pend?.date)} por{" "}
                            {pend?.changes?.creator}.
                          </div>
                          <div className="actions">
                            {userpgi === "Gerente" ? (
                              <>
                                <OverlayTrigger
                                  key="1"
                                  placement="top"
                                  overlay={
                                    <Tooltip id="1">Aceptar cambio</Tooltip>
                                  }>
                                  <button
                                    className="accept"
                                    onClick={() => handleApproved(pend?._id)}>
                                    <CheckBoxOutlined />
                                  </button>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  key="2"
                                  placement="top"
                                  overlay={
                                    <Tooltip id="2">Rechazar cambio</Tooltip>
                                  }>
                                  <button
                                    className="reject"
                                    onClick={() => handleDelete(pend?._id)}>
                                    <DisabledByDefaultOutlined />
                                  </button>
                                </OverlayTrigger>
                              </>
                            ) : (
                              <OverlayTrigger
                                key="2"
                                placement="top"
                                overlay={
                                  <Tooltip id="2">Editar cambio</Tooltip>
                                }>
                                <button className="reject">
                                  <SidebarFaqs
                                    isEdit={true}
                                    faqsToEdit={pend?.changes}
                                  />
                                </button>
                              </OverlayTrigger>
                            )}
                          </div>
                        </li>
                      )
                  )}
                </ul>
              ) : (
                <p>No hay pendientes</p>
              )}
            </div>
          </div>
          <div className="card" id="pgiNotifEmpresa">
            <header aria-labelledby="pgiNotifEmpresa">
              <h2>
                <span className="text">
                  <ArtTrack /> BLOQUE INFORMACIÓN
                </span>
                <span className="badge">{cantidadBloque?.length}</span>
              </h2>
            </header>
            <div className="pgi__notificaciones">
              {cantidadBloque?.length ? (
                <ul>
                  {latestElements?.map(
                    (pend, index) =>
                      pend?.changes?.element === 4 &&
                      pend.checked === false && (
                        <li key={index}>
                          <div
                            className="description"
                            onClick={() => handleModalClick(pend)}>
                            {pend.method === "POST" && (
                              <span className="badge public">Creado</span>
                            )}
                            {pend.method === "DELETE" && (
                              <span className="badge delete">Eliminado</span>
                            )}
                            {pend.method === "PUT" && (
                              <span className="badge edit">Editado</span>
                            )}
                            <b>{pend?.changes?.title_content}</b>, el{" "}
                            {formatearFecha(pend?.date)} por{" "}
                            {pend?.changes?.creator}.
                          </div>
                          <div className="actions">
                            {userpgi === "Gerente" ? (
                              <>
                                <OverlayTrigger
                                  key="1"
                                  placement="top"
                                  overlay={
                                    <Tooltip id="1">Aceptar cambio</Tooltip>
                                  }>
                                  <button
                                    className="accept"
                                    onClick={() => handleApproved(pend?._id)}>
                                    <CheckBoxOutlined />
                                  </button>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  key="2"
                                  placement="top"
                                  overlay={
                                    <Tooltip id="2">Rechazar cambio</Tooltip>
                                  }>
                                  <button
                                    className="reject"
                                    onClick={() => handleDelete(pend?._id)}>
                                    <DisabledByDefaultOutlined />
                                  </button>
                                </OverlayTrigger>
                              </>
                            ) : (
                              <OverlayTrigger
                                key="2"
                                placement="top"
                                overlay={
                                  <Tooltip id="2">Editar cambio</Tooltip>
                                }>
                                <button
                                  className="reject"
                                  onClick={() =>
                                    setBloqueInfoEdit(pend?.changes)
                                  }>
                                  <BloqueTxtPgi
                                    showBloque={false}
                                    infoEdit={pend?.changes}
                                  />
                                </button>
                              </OverlayTrigger>
                            )}
                          </div>
                        </li>
                      )
                  )}
                </ul>
              ) : (
                <p>No hay pendientes</p>
              )}
            </div>
          </div>

          <div className="card" id="pgiNotifEmpresa">
            <header aria-labelledby="pgiNotifEmpresa">
              <h2>
                <span className="text">
                  <HighlightAlt /> BANNER DE PUBLICIDAD
                </span>
                <span className="badge">{cantidadBannerPub?.length}</span>
              </h2>
            </header>
            <div className="pgi__notificaciones">
              {cantidadBannerPub?.length ? (
                <ul>
                  {latestElements?.map(
                    (pend, index) =>
                      pend?.changes?.element === 5 &&
                      pend.checked === false && (
                        <li key={index}>
                          <div
                            className="description"
                            onClick={() => handleModalClick(pend)}>
                            {pend.method === "POST" && (
                              <span className="badge public">Creado</span>
                            )}
                            {pend.method === "DELETE" && (
                              <span className="badge delete">Eliminado</span>
                            )}
                            {pend.method === "PUT" && (
                              <span className="badge edit">Editado</span>
                            )}
                            <b>{pend?.changes?.title}</b>, el{" "}
                            {formatearFecha(pend?.date)} por{" "}
                            {pend?.changes?.creator}.
                          </div>
                          <div className="actions">
                            {userpgi === "Gerente" ? (
                              <>
                                <OverlayTrigger
                                  key="1"
                                  placement="top"
                                  overlay={
                                    <Tooltip id="1">Aceptar cambio</Tooltip>
                                  }>
                                  <button
                                    className="accept"
                                    onClick={() => handleApproved(pend?._id)}>
                                    <CheckBoxOutlined />
                                  </button>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  key="2"
                                  placement="top"
                                  overlay={
                                    <Tooltip id="2">Rechazar cambio</Tooltip>
                                  }>
                                  <button
                                    className="reject"
                                    onClick={() => handleDelete(pend?._id)}>
                                    <DisabledByDefaultOutlined />
                                  </button>
                                </OverlayTrigger>
                              </>
                            ) : (
                              <button
                                className="reject"
                                onClick={() => setBannerEdit(pend?.changes)}>
                                <BannerPubPgi
                                  showBloque={false}
                                  infoEdit={pend?.changes}
                                />
                              </button>
                            )}
                          </div>
                        </li>
                      )
                  )}
                </ul>
              ) : (
                <p>No hay pendientes</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        id="galleryModal"
        className="modalContenedor__galeria pgi-audit"
        show={showGaleria}
        onHide={handleCloseGaleria}>
        <Modal.Header closeButton>
          <div className="description pgi__notificaciones">
            {modalFor?.method === "POST" && (
              <span className="badge public">Creado</span>
            )}
            {modalFor?.method === "DELETE" && (
              <span className="badge delete">Eliminado</span>
            )}
            {modalFor?.method === "PUT" && (
              <span className="badge edit">Editado</span>
            )}
            <b>
              {modalFor?.element === 3
                ? modalFor?.changes?.category
                : modalFor?.element === 4
                ? modalFor?.changes?.title_content
                : modalFor?.changes?.title}
            </b>
            , el {formatearFecha(modalFor?.date)} por{" "}
            {modalFor?.changes?.creator}.
          </div>
          <div className="actions pgi__notificaciones">
            <ul>
              <li>
                {userpgi === "Gerente" && (
                  <>
                    <OverlayTrigger
                      key="1"
                      placement="top"
                      overlay={<Tooltip id="1">Aceptar cambio</Tooltip>}>
                      <button
                        className="accept"
                        onClick={() => handleApproved(modalFor?._id)}>
                        <CheckBoxOutlined />
                      </button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      key="2"
                      placement="top"
                      overlay={<Tooltip id="2">Rechazar cambio</Tooltip>}>
                      <button
                        className="reject"
                        onClick={() => handleDelete(modalFor?._id)}>
                        <DisabledByDefaultOutlined />
                      </button>
                    </OverlayTrigger>
                  </>
                )}
              </li>
            </ul>
          </div>
        </Modal.Header>
        <Modal.Body>
          {modalFor?.element === 0 && (
            <ArticlesAudit pendientes={modalFor} auditoria={true} />
          )}
          {modalFor?.element === 1 && (
            <Noticias noticia={modalFor?.changes} auditoria={true} />
          )}
          {modalFor?.element === 2 && (
            <Products product={modalFor?.changes} auditoria={true} />
          )}
          {modalFor?.element === 3 && (
            <FaqsAudit faqs={modalFor?.changes} auditoria={true} />
          )}
          {modalFor?.element === 4 && (
            <BloqueInfoAudit
              modulesBloqueInfo={modalFor?.changes}
              auditoria={true}
            />
          )}
          {modalFor?.element === 5 && (
            <BannerAudit banner={modalFor?.changes} auditoria={true} />
          )}
        </Modal.Body>
      </Modal>
    </div>
  ) : (
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  )
}

export default Index
